// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {
  install(Vue, options) {
    Vue.prototype.ExportSavePdf = function (title,pageNote,idNames) {
      if(idNames.length > 0){
        window.scrollTo(0,0);

        let temp = function(idName){
          return new Promise((resolve, reject) => {
            html2Canvas(document.querySelector('#'+idName),{
              allowTaint: true,
              logging: false,
              // dpi: 4, //将分辨率提高到特定的DPI 提高四倍
              // scale:4 //按比例增加分辨率
            }).then(function (canvas){


              resolve(canvas);
            })
          })
        };
        let promiseArray = [];
        idNames.forEach((item)=>{
          promiseArray.push(temp(item));
        })
        Promise.all(promiseArray).then((result)=>{
          //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
          //当内容未超过pdf一页显示的范围，无需分页

          var pdf = new JsPDF("p", "mm", "a4"); // A4纸，纵向
          let pageSize = 0;
          result.forEach((item,index)=>{
            pageSize++;
            if(index != result.length - 1){
              pdf.addPage();
            }
            pdf.setPage(pageSize)
            var ctx = item.getContext("2d");
            var a4w = 210;
            var a4h = 297; // A4大小，210mm x 297mm，四边各保留20mm的边距，显示区域170x257
            if(index == 0){
              a4h = 290; // A4大小，210mm x 297mm，四边各保留20mm的边距，显示区域170x257
            }
            var imgHeight = Math.floor((a4h * item.width) / a4w); // 按A4显示比例换算一页图像的像素高度
            let pages = Math.ceil(item.height/imgHeight)
            var renderedHeight = 0;
            while (renderedHeight < item.height) {
              var page = document.createElement("canvas");
              page.width = item.width;
              page.height = Math.min(imgHeight, item.height - renderedHeight); // 可能内容不足一页

              // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
              page
                .getContext("2d")
                .putImageData(
                  ctx.getImageData(
                    0,
                    renderedHeight,
                    item.width,
                    Math.min(imgHeight, item.height - renderedHeight)
                  ),
                  0,
                  0
                );
              if(pages > 1 && pageSize != 1){
                // 设置中文字体
                // pdf.addFont('SourceHanSans-Normal.ttf', 'SourceHanSans-Normal', 'normal');
                // pdf.setFont('SourceHanSans-Normal');
                // console.log('method:html22Pdf-- 86-- SIMSUNB_NORMAL_FONT --', SIMSUNB_NORMAL_FONT );
                // var callAddFont = function(){
                //   this.addFileToVFS('simsunb-normal.ttf',SIMSUNB_NORMAL_FONT);
                //   this.addFont('simsunb-normal.ttf','simsunb','normal');
                // };
                // JsPDF.API.events.push(['addFonts',callAddFont]);
                // pdf.setFont('simsunb-normal')
                // 设置文字大小
                pdf.setFontSize(8);
                // 设置文字颜色
                pdf.setTextColor('#535353');
                pdf.text(pageNote,10, 8); //

                pdf.addImage(
                  page.toDataURL("image/jpeg", 1.0),
                  "JPEG",
                  0, 10,
                  a4w,
                  Math.min(a4h, (a4w * page.height) / page.width)
                );
              }else{
                pdf.addImage(
                  page.toDataURL("image/jpeg", 1.0),
                  "JPEG",
                  0, 0,
                  a4w,
                  Math.min(a4h, (a4w * page.height) / page.width)
                );
              }

              //页码
              // const pageHeight = pdf.internal.pageSize.height;
              // const margin = 5; // 页码与页脚边缘的间距
              // const pageNumberY = pageHeight - margin; // 页码在 Y 轴上的位置
              // const pageContent = `${pageSize}`; // 页码从1开始
              // // pdf.text(pageContent, pdf.internal.pageSize.width - 20, pageNumberY); //
              // pdf.text(pageContent,20, margin); //
              renderedHeight += imgHeight;
              if (renderedHeight < item.height) {

                pdf.addPage();
                pageSize++;
                pdf.setPage(pageSize)
              } // 如果后面还有内容，添加一个空页
              // delete page;

            }


          })
          pdf.save(title+'.pdf')
        })
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/htmlToPdf.js